import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  banks: [],
  bankData: {},
  error: "",
  success: "",
};

const BankSlice = createSlice({
  name: "Banks",
  initialState,
  reducers: {
    setBanks(state, action) {
      state.banks = action.payload;
    },
    setBankData(state, action) {
      state.bankData = action.payload;
    },
    clearBankData(state) {
      state.bankData = {};
    },
    bankError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setBanks, setBankData, clearBankData, bankError } = BankSlice.actions;

export default BankSlice.reducer;
